import React, { useState } from "react";
import { Mail, CheckCircle2, Send, KeyRound } from "lucide-react";
import { Alert, Spinner } from "./ui";
import { api, formatApiError } from "../lib/api";

export default function EmailVerification({ emailVerified, onVerified }) {
  const [step, setStep] = useState(emailVerified ? "done" : "idle");
  const [maskedEmail, setMaskedEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  const sendOtp = async () => {
    setLoading(true);
    setError("");
    setMsg("");
    try {
      const { data } = await api.post("/api/auth/email/verify/send", {});
      setMaskedEmail(data.masked_email);
      setStep("input");
      setMsg(`Kode verifikasi dikirim ke ${data.masked_email}`);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const verifyCode = async () => {
    if (!code || code.length !== 6) {
      setError("Masukkan 6 digit kode verifikasi");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/api/auth/email/verify/confirm", { code });
      setStep("done");
      setMsg("");
      if (onVerified) onVerified();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (emailVerified || step === "done") {
    return (
      <div className="flex items-center gap-2 p-3 bg-success-50 rounded-xl">
        <CheckCircle2 className="h-5 w-5 text-success-600 flex-shrink-0" />
        <div>
          <p className="font-bold text-success-700 text-sm">Email Terverifikasi</p>
          <p className="text-xs text-success-600">Email akun Anda sudah terverifikasi</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl border-2 border-amber-200 bg-amber-50 p-4 space-y-3">
      <div className="flex items-center gap-2">
        <Mail className="h-5 w-5 text-amber-600 flex-shrink-0" />
        <div>
          <p className="font-bold text-amber-700 text-sm">Email Belum Terverifikasi</p>
          <p className="text-xs text-amber-600">Verifikasi email untuk keamanan akun</p>
        </div>
      </div>

      {error && <Alert kind="error">{error}</Alert>}
      {msg && <Alert kind="success">{msg}</Alert>}

      {step === "idle" && (
        <button
          onClick={sendOtp}
          disabled={loading}
          className="btn-primary w-full text-sm !py-2"
          data-testid="send-otp-btn"
        >
          {loading ? <Spinner /> : <span className="flex items-center gap-2"><Send className="h-4 w-4" /> Kirim Kode Verifikasi</span>}
        </button>
      )}

      {step === "input" && (
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <KeyRound className="h-4 w-4 text-amber-600" />
            <label className="text-sm font-medium text-amber-700">Masukkan 6 digit kode</label>
          </div>
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
            className="w-full rounded-xl border-2 border-amber-200 px-3 py-2.5 text-sm tracking-widest text-center font-mono focus:border-brand-500 focus:outline-none bg-white"
            placeholder="000000"
            data-testid="otp-input"
          />
          <div className="flex gap-2">
            <button
              onClick={() => { setStep("idle"); setCode(""); setError(""); setMsg(""); }}
              className="btn-ghost flex-1 text-sm !py-2"
            >
              Kembali
            </button>
            <button
              onClick={verifyCode}
              disabled={loading || code.length !== 6}
              className="btn-primary flex-1 text-sm !py-2"
              data-testid="verify-otp-btn"
            >
              {loading ? "Memverifikasi..." : "Verifikasi"}
            </button>
          </div>
          <button
            onClick={sendOtp}
            disabled={loading}
            className="text-xs text-amber-600 hover:underline w-full text-center"
          >
            Kirim ulang kode
          </button>
        </div>
      )}
    </div>
  );
}
